import Utils from '../../utils/utils'
import Storage from '../storage/storage'
import Reguest from '../../utils/reguest'
import Socket from '../socket'
import Timeline from './timeline'
import Bookmarks from './bookmarks'
import Listener from './listener'
import Permit from './permit'
import Profile from './profile'
import Panel from './panel'
import Device from './device'
import Api from './api'
import Modal from './modal'
import Timer from '../timer'
import Noty from '../../interaction/noty'
import Lang from '../lang'

let network = new Reguest()
let user_data


/**
 * Запуск
 */
function init(){
    if(!window.lampa_settings.account_use) return

    console.log('Account','use', Permit.token ? Permit.account.email : 'no account')

    Timeline.init()
    Bookmarks.init()
    Profile.init()
    Panel.init()
    Device.init()

    // Реакция на смену подписки. refreshUser (периодический опрос) шлёт 'premium'
    // при любом изменении статуса — если премиум активировался прямо в этой сессии
    // (0 → активна), сразу уведомляем юзера. Фичи/реклама уже применяются по
    // Account.hasPremium() на своих местах.
    Listener.follow('premium', onPremiumChange)

    Socket.listener.follow('open', checkAccountValidity)
    Socket.listener.follow('open', refreshUser)

    Timer.add(1000 * 60 * 10, checkAccountValidity)
    Timer.add(1000 * 10, refreshUser)

    Profile.check(()=>{
        refreshUser()

        Timeline.update()

        Profile.update()

        Api.persons()
    })

    delete Account.init
}

/**
 * Задача загрузки приложения
 * @param {Function} call - функция обратного вызова
 * @return {void}
 */
function task(call){
    if(!window.lampa_settings.account_use) return call()

    Bookmarks.update(call)
}

/**
 * Проверить валидность аккаунта
 * @return {void}
 */
function checkAccountValidity(){
    Permit.token && Socket.send('check_token',{})
}

function refreshUser(done){
    if(!Permit.token) return done && done()

    Api.user(user=>{
        let was = user_data && user_data.premium
        user_data = user

        if(was !== user.premium) Listener.send('premium', {premium: user.premium})

        if(done) done(user)
    }, ()=>{
        if(done) done()
    })
}

// Последнее известное состояние премиума в этой сессии (null — ещё не знаем).
let premium_seen = null

// Обработчик 'premium'. Уведомляем только на РЕАЛЬНОЙ активации (0 → премиум)
// в течение сессии; на первичной синхронизации (premium_seen == null) молчим,
// иначе премиум-юзер видел бы «Подписка активна» при каждом запуске.
function onPremiumChange(){
    let active = Boolean(Account.hasPremium())

    if(premium_seen === false && active){
        Noty.show(Lang.translate('subscription_activated'))
    }

    premium_seen = active
}

// Активный опрос юзера для окон оплаты: пока открыт QR, опрашиваем бэкенд чаще
// (по умолчанию раз в 5с), чтобы оплата с телефона подхватилась за секунды.
// onTick вызывается после каждого обновления. Возвращает функцию-стоп.
function watchUser(onTick, interval = 5000){
    if(!Permit.token) return ()=>{}

    let timer = setInterval(()=>{
        refreshUser(()=>{ if(onTick) onTick() })
    }, interval)

    return ()=> clearInterval(timer)
}

/**
 * Выход из аккаунта
 * @param {Object} data - данные аккаунта
 * @return {void}
 */
function logoff(data){
    let account = Permit.account

    if(account.token && account.email == data.email){
        Storage.set('account','',true)
        Storage.set('account_use',false,true)
        Storage.set('account_user','',true)
        Storage.set('account_email','',true)
        Storage.set('account_notice','',true)
        Storage.set('account_bookmarks','',true)

        $('.head .open--profile').addClass('hide')

        window.location.reload()
    }
}


let Account = {
    Api,
    Bookmarks,
    Profile,
    Timeline,
    Permit,
    Modal,

    listener: Listener,
    network,

    init,
    task,
    working: ()=>{
        console.warn('Account.working() is deprecated, use Account.Permit.sync')

        return Permit.sync
    },
    canSync: ()=>{
        console.warn('Account.canSync() is deprecated, use Account.Permit.sync ? Account.Permit.account : false')

        return Permit.sync ? Permit.account : false
    },
    workingAccount: ()=>{
        console.warn('Account.workingAccount() is deprecated, use Account.Permit.sync ? Account.Permit.account : false')

        return Permit.sync ? Permit.account : false
    },
    logged: ()=>{
        console.warn('Account.logged() is deprecated, use Permit.access')

        return Permit.access
    },
    get: (params)=>{
        console.warn('Account.get() is deprecated, use Account.Bookmarks.get()')

        return Bookmarks.get(params)
    },
    all: ()=>{
        console.warn('Account.all() is deprecated, use Account.Bookmarks.all()')

        return Bookmarks.all()
    },
    plugins: (call)=>{
        console.warn('Account.plugins() is deprecated, use Account.Api.plugins()')

        Api.plugins(call)
    },
    notice: (call)=>{
        console.warn('Account.notice() is deprecated, use Account.Api.notices()')

        Api.notices(call)
    },
    pluginsStatus: (plugin, status)=>{
        console.warn('Account.pluginsStatus() is deprecated, use Account.Api.pluginToggle()')

        Api.pluginToggle(plugin, status)
    },
    showProfiles: (callback)=>{
        console.warn('Account.showProfiles() is deprecated, use Account.Profile.select()')

        Profile.select(callback)
    },
    clear: (where)=>{
        console.warn('Account.clear() is deprecated, use Account.Bookmarks.clear()')

        Bookmarks.clear(where)
    },
    update: (call)=>{
        console.warn('Account.update() is deprecated, use Account.Bookmarks.update()')

        Bookmarks.update(call)
    },
    backup: ()=>{
        console.warn('Account.backup() is deprecated')
    },
    subscribeToTranslation: (params, call, error)=>{
        console.warn('Account.subscribeToTranslation() is deprecated, use Account.Api.subscribeToTranslation()')

        Api.subscribeToTranslation(params, call, error)
    },
    subscribes: (params, secuses, error)=>{
        console.warn('Account.subscribes() is deprecated, use Account.Api.subscribes()')

        Api.subscribes(params, secuses, error)
    },
    showNoAccount: ()=>{
        console.warn('Account.showNoAccount() is deprecated, use Account.Modal.account()')

        Modal.account()
    },
    showCubPremium: ()=>{
        console.warn('Account.showCubPremium() is deprecated, use Account.Modal.premium()')

        Modal.premium()
    },
    showLimitedAccount: ()=>{
        console.warn('Account.showLimitedAccount() is deprecated, use Account.Modal.limited()')

        Modal.limited()
    },
    logoff,
    persons: ()=>{
        console.warn('Account.persons() is deprecated, use Account.Api.persons()')

        Api.persons()
    },
    updateUser: (done)=>{
        refreshUser(done)
    },
    // Активный опрос юзера (окна оплаты) — см. watchUser выше.
    watchUser
}

Object.defineProperty(Account, 'hasPremium', {
    value: function() {
        let user = user_data || Storage.get('account_user','{}')

        if(Storage.get('developer_nopremium', 'false')) return 0

        return user.id ? Utils.countDays(Date.now(), user.premium) : 0
    },
    writable: false
})

export default Account